"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Json = _interopRequireDefault(require("./Json"));

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * @name ChainProperties
 * @description
 * Wraps the properties retrieved from the chain via the `system.properties` RPC call.
 */
class ChainProperties extends _Json.default {
  /**
   * @description The token decimals, if defined (de-facto standard only)
   */
  get tokenDecimals() {
    return this.get('tokenDecimals');
  }
  /**
   * @description The token system, if defined (de-facto standard only)
   */


  get tokenSymbol() {
    return this.get('tokenSymbol');
  }

}

exports.default = ChainProperties;